import React, {
  memo,
  useCallback,
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react"
import { FullScreen, useFullScreenHandle } from "react-full-screen"

const colorArray = [
  "#ededed",
  "#FF0000",
  "#00FF00",
  "#0000FF",
  "#000000",
  "#FFFFFF",
  "#eee",
]
let isReset = false

const PikselFs = forwardRef((props, ref) => {
  const [fscreen, setFscreen] = useState(false)
  const [colorIndex, setColorIndex] = useState(0)
  const screen1 = useFullScreenHandle()
  const reportChange = (state, handle) => {
    if (!state) {
      setFscreen(false)
    }
  }
  useImperativeHandle(ref, () => ({
    open: () => {
      setColorIndex(0)
      screen1.enter()
      setFscreen(true)
    },
    reset: () => {
      isReset = true
    },
    close: () => {
      screen1.exit()
    },
  }))
  const changeBg = () => {
    if (isReset) {
      setColorIndex(0)
      isReset = false
    } else {
      const newIndex =
        colorIndex === colorArray.length - 1 ? colorIndex : colorIndex + 1
      setColorIndex(newIndex % colorArray.length)
    }
  }
  const previousBg = () => {
    const newIndex = colorIndex === 0 ? 0 : colorIndex - 1
    setColorIndex(newIndex % colorArray.length)
  }

  const cbChangeBg = useCallback(changeBg, [colorIndex])
  const cbPreviousBg = useCallback(previousBg, [colorIndex])
  const handleUserKeyPress = useCallback(
    event => {
      const { key, keyCode, code } = event
      if (keyCode === 39 || key === "ArrowRight" || code === "ArrowRight") {
        cbChangeBg()
      } else if (
        keyCode === 37 ||
        key === "ArrowLeft" ||
        code === "ArrowLeft"
      ) {
        cbPreviousBg()
      }
    },
    [cbChangeBg, cbPreviousBg]
  )

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress)
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress)
    }
  }, [handleUserKeyPress])
  return (
    <FullScreen handle={screen1} onChange={reportChange}>
      {fscreen && (
        <div
          aria-hidden="true"
          role="button"
          tabIndex={0}
          onClick={changeBg}
          className="flex items-center justify-center w-full h-full cursor-pointer"
          style={{ backgroundColor: colorArray[colorIndex] }}
        >
          {colorIndex === 0 && props.startIndicator}
          {colorIndex === colorArray.length - 1 && props.endIndicator}
        </div>
      )}
    </FullScreen>
  )
})
export default memo(PikselFs)
